import { ApprovalModalForm } from "./ApprovalModalForm";

const ApprovalModalFormWrapper = ({
selectedItem,
setSelectedItem,
setOpenApprovalModal,
fieldType,
isLoading,
onUpdate
}) => {

  if (selectedItem) {
    return (
      <ApprovalModalForm
        selectedItem={selectedItem}
        setSelectedItem={setSelectedItem}
        setOpenApprovalModal={setOpenApprovalModal}
        fieldType={fieldType}
        isLoading={isLoading}
        onUpdate={onUpdate}
      />
    );
  }
  return null;
};

export { ApprovalModalFormWrapper };
